/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал передачи сигналов
 */

/**
 * Сигнал.
 * Если информация неизвестна то колонки заполняются следующим образом:
 * 1/ Cтрока - как пустая строка;
 * 2/ Цифра - как 0;
 * 3/ Массив - как пустой массив;
 * Некоторые данные в одних и тех же сигналах могут отсутствовать.
 * Так как в момент создания сигнала их нет в тех сервисах в которых они выполняются.
 * Все виды сигналов передаются в топиках: key.signal.*
 */
export type SignalRequestDto = {
  /**
   * Время возникновения сигнала.
   * В секундах от 01.01.1970 года в UTC.
   * Присутствует всегда
   */
  time?: string
  /**
   * Название сигнала.
   * Присутствует всегда
   */
  name?: string
  /**
   * Информация о субъекте действия с которым связан сигнал.
   * К чему сигнал относится.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  subject?: SignalEntityRequestDto | null
  /**
   * Текстовая информация.
   * К примеру текст ошибки.
   * Может отсутствовать
   */
  message?: string
  /**
   * Информация о подписке с которой связан сигнал.
   * Характеризует что доступно или не доступно пользователю.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  subscription?: SignalSubscriptionRequestDto | null
  /**
   * Информация о выставленном счёте с которым связан сигнал.
   * Характеризует состояние оплаты.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  invoice?: SignalInvoiceRequestDto | null
  /**
   * Информация о объекте действия с которым связан сигнал.
   * К чему сигнал относится.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  object?: SignalEntityRequestDto | null
  /**
   * Дополнительная полезная нагрузка.
   * К примеру тэги.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload?: {[key:string]:string}
  /**
   * Мета информация.
   * Некоторая информация которая присутствует в запросе.
   * К примеру это http заголовки запроса: X-Request-Id, User-Agent, X-Forwarded-For и тд
   */
  meta?: {[key:string]:string}
}
/**
 * Сигнал.
 * Если информация неизвестна то колонки заполняются следующим образом:
 * 1/ Cтрока - как пустая строка;
 * 2/ Цифра - как 0;
 * 3/ Массив - как пустой массив;
 * Некоторые данные в одних и тех же сигналах могут отсутствовать.
 * Так как в момент создания сигнала их нет в тех сервисах в которых они выполняются.
 * Все виды сигналов передаются в топиках: key.signal.*
 */
export type SignalResponseDto = {
  /**
   * Время возникновения сигнала.
   * В секундах от 01.01.1970 года в UTC.
   * Присутствует всегда
   */
  time: string
  /**
   * Название сигнала.
   * Присутствует всегда
   */
  name: string
  /**
   * Информация о субъекте действия с которым связан сигнал.
   * К чему сигнал относится.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  subject: SignalEntityResponseDto | null
  /**
   * Текстовая информация.
   * К примеру текст ошибки.
   * Может отсутствовать
   */
  message: string
  /**
   * Информация о подписке с которой связан сигнал.
   * Характеризует что доступно или не доступно пользователю.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  subscription: SignalSubscriptionResponseDto | null
  /**
   * Информация о выставленном счёте с которым связан сигнал.
   * Характеризует состояние оплаты.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  invoice: SignalInvoiceResponseDto | null
  /**
   * Информация о объекте действия с которым связан сигнал.
   * К чему сигнал относится.
   * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
   * Может отсутствовать
   */
  object: SignalEntityResponseDto | null
  /**
   * Дополнительная полезная нагрузка.
   * К примеру тэги.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload: {[key:string]:string}
  /**
   * Мета информация.
   * Некоторая информация которая присутствует в запросе.
   * К примеру это http заголовки запроса: X-Request-Id, User-Agent, X-Forwarded-For и тд
   */
  meta: {[key:string]:string}
}
/**
 * Сущность
 */
export type SignalEntityRequestDto = {
  /**
   * Область размещения.
   * Обычно это идентификатор дома в стандарте ОРПОН.
   * Может отсутствовать
   */
  placeId?: string
  /**
   * Место размещение.
   * Обычно это номер квартиры.
   * Может отсутствовать
   */
  placeLabel?: string
  /**
   * Идентификатор пользователя.
   * Может отсутствовать
   */
  userId?: string
  /**
   * Лейбл пользователя.
   * Обычно это тип/роль пользователя.
   * Может отсутствовать
   */
  userLabel?: string
  /**
   * Идентификатор группы.
   * Обычно это идентификатор компании.
   * Может отсутствовать
   */
  groupId?: string
  /**
   * Название группы.
   * Обычно это название компании.
   * Может отсутствовать
   */
  groupTitle?: string
  /**
   * Идентификатор устройства.
   * Может отсутствовать
   */
  deviceId?: string
  /**
   * Лейбл устройства.
   * Может отсутствовать
   */
  deviceLabel?: string
  /**
   * Индекс реле устройства.
   * Может отсутствовать
   */
  deviceRelayIndex?: string
  /**
   * Идентификатор камеры.
   * Может отсутствовать
   */
  cameraId?: string
  /**
   * Лейбл камеры.
   * Может отсутствовать
   */
  cameraLabel?: string
  /**
   * Номер ключа.
   * Может отсутствовать
   */
  key?: string
  /**
   * Код.
   * Может отсутствовать
   */
  code?: string
  /**
   * ДТМФ код открытия.
   * Может отсутствовать
   */
  dtmfCode?: string
  /**
   * Номер телефона.
   * Может отсутствовать
   */
  phone?: string
  /**
   * Дополнительная полезная нагрузка.
   * К примеру дополнительные детали сущности.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload?: {[key:string]:string}
  /**
   * Почтовый адрес.
   * Может отсутствовать
   */
  email?: string
}
/**
 * Сущность
 */
export type SignalEntityResponseDto = {
  /**
   * Область размещения.
   * Обычно это идентификатор дома в стандарте ОРПОН.
   * Может отсутствовать
   */
  placeId: string
  /**
   * Место размещение.
   * Обычно это номер квартиры.
   * Может отсутствовать
   */
  placeLabel: string
  /**
   * Идентификатор пользователя.
   * Может отсутствовать
   */
  userId: string
  /**
   * Лейбл пользователя.
   * Обычно это тип/роль пользователя.
   * Может отсутствовать
   */
  userLabel: string
  /**
   * Идентификатор группы.
   * Обычно это идентификатор компании.
   * Может отсутствовать
   */
  groupId: string
  /**
   * Название группы.
   * Обычно это название компании.
   * Может отсутствовать
   */
  groupTitle: string
  /**
   * Идентификатор устройства.
   * Может отсутствовать
   */
  deviceId: string
  /**
   * Лейбл устройства.
   * Может отсутствовать
   */
  deviceLabel: string
  /**
   * Индекс реле устройства.
   * Может отсутствовать
   */
  deviceRelayIndex: string
  /**
   * Идентификатор камеры.
   * Может отсутствовать
   */
  cameraId: string
  /**
   * Лейбл камеры.
   * Может отсутствовать
   */
  cameraLabel: string
  /**
   * Номер ключа.
   * Может отсутствовать
   */
  key: string
  /**
   * Код.
   * Может отсутствовать
   */
  code: string
  /**
   * ДТМФ код открытия.
   * Может отсутствовать
   */
  dtmfCode: string
  /**
   * Номер телефона.
   * Может отсутствовать
   */
  phone: string
  /**
   * Дополнительная полезная нагрузка.
   * К примеру дополнительные детали сущности.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload: {[key:string]:string}
  /**
   * Почтовый адрес.
   * Может отсутствовать
   */
  email: string
}
/**
 * Информация о выставленном счёте
 */
export type SignalInvoiceRequestDto = {
  /**
   * Идентификато выставленного счёта.
   * Может отсутствовать
   */
  id?: string
  /**
   * Назначение выставленного счёта.
   * Может отсутствовать
   */
  title?: string
  /**
   * Общая сумма чека.
   * В рублях.
   * Может отсутствовать
   */
  totalAmount?: number
  /**
   * Статус выставленного счёта.
   * Может отсутствовать
   */
  status?: string
  /**
   * Номер телефона на который пользователь хочет получить информацию об оплате.
   * Может отсутствовать
   */
  phone?: string
  /**
   * Почта на которую пользователь хочет получить информацию об оплате.
   * Может отсутствовать
   */
  email?: string
  /**
   * Идентификаторы товаров позиций на которые выставленн счёт.
   * Обычно это идентификаторы подписок.
   * Может отсутствовать
   */
  positionIds?: string[]
  /**
   * Дополнительная полезная нагрузка.
   * К примеру дополнительные детали выставленного счёта.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload?: {[key:string]:string}
}
/**
 * Информация о выставленном счёте
 */
export type SignalInvoiceResponseDto = {
  /**
   * Идентификато выставленного счёта.
   * Может отсутствовать
   */
  id: string
  /**
   * Назначение выставленного счёта.
   * Может отсутствовать
   */
  title: string
  /**
   * Общая сумма чека.
   * В рублях.
   * Может отсутствовать
   */
  totalAmount: number
  /**
   * Статус выставленного счёта.
   * Может отсутствовать
   */
  status: string
  /**
   * Номер телефона на который пользователь хочет получить информацию об оплате.
   * Может отсутствовать
   */
  phone: string
  /**
   * Почта на которую пользователь хочет получить информацию об оплате.
   * Может отсутствовать
   */
  email: string
  /**
   * Идентификаторы товаров позиций на которые выставленн счёт.
   * Обычно это идентификаторы подписок.
   * Может отсутствовать
   */
  positionIds: string[]
  /**
   * Дополнительная полезная нагрузка.
   * К примеру дополнительные детали выставленного счёта.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload: {[key:string]:string}
}
/**
 * Информация о подписке
 */
export type SignalSubscriptionRequestDto = {
  /**
   * Идентификатор подписки.
   * Может отсутствовать
   */
  id?: string
  /**
   * Название подписки.
   * Может отсутствовать
   */
  title?: string
  /**
   * Статус подписки.
   * Может отсутствовать
   */
  status?: string
  /**
   * Привилегии подписок.
   * Может отсутствовать
   */
  privileges?: string[]
  /**
   * Дополнительная полезная нагрузка.
   * К примеру дополнительные детали подписки.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload?: {[key:string]:string}
}
/**
 * Информация о подписке
 */
export type SignalSubscriptionResponseDto = {
  /**
   * Идентификатор подписки.
   * Может отсутствовать
   */
  id: string
  /**
   * Название подписки.
   * Может отсутствовать
   */
  title: string
  /**
   * Статус подписки.
   * Может отсутствовать
   */
  status: string
  /**
   * Привилегии подписок.
   * Может отсутствовать
   */
  privileges: string[]
  /**
   * Дополнительная полезная нагрузка.
   * К примеру дополнительные детали подписки.
   * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
   */
  payload: {[key:string]:string}
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Сигнал.
   * Если информация неизвестна то колонки заполняются следующим образом:
   * 1/ Cтрока - как пустая строка;
   * 2/ Цифра - как 0;
   * 3/ Массив - как пустой массив;
   * Некоторые данные в одних и тех же сигналах могут отсутствовать.
   * Так как в момент создания сигнала их нет в тех сервисах в которых они выполняются.
   * Все виды сигналов передаются в топиках: key.signal.*
   */
  "Signal": {
    "kind": "class",
    "text": "Сигнал.\nЕсли информация неизвестна то колонки заполняются следующим образом:\n1/ Cтрока - как пустая строка;\n2/ Цифра - как 0;\n3/ Массив - как пустой массив;\nНекоторые данные в одних и тех же сигналах могут отсутствовать.\nТак как в момент создания сигнала их нет в тех сервисах в которых они выполняются.\nВсе виды сигналов передаются в топиках: key.signal.*",
    "fields": {
      /**
       * Время возникновения сигнала.
       * В секундах от 01.01.1970 года в UTC.
       * Присутствует всегда
       */
      "time": {
        "type": "int64",
        "text": "Время возникновения сигнала.\nВ секундах от 01.01.1970 года в UTC.\nПрисутствует всегда",
      },
      /**
       * Название сигнала.
       * Присутствует всегда
       */
      "name": {
        "type": "string",
        "text": "Название сигнала.\nПрисутствует всегда",
      },
      /**
       * Информация о субъекте действия с которым связан сигнал.
       * К чему сигнал относится.
       * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
       * Может отсутствовать
       */
      "subject": {
        "type": "Signal.Entity",
        "text": "Информация о субъекте действия с которым связан сигнал.\nК чему сигнал относится.\nЗаполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.\nМожет отсутствовать",
      },
      /**
       * Текстовая информация.
       * К примеру текст ошибки.
       * Может отсутствовать
       */
      "message": {
        "type": "string",
        "text": "Текстовая информация.\nК примеру текст ошибки.\nМожет отсутствовать",
      },
      /**
       * Информация о подписке с которой связан сигнал.
       * Характеризует что доступно или не доступно пользователю.
       * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
       * Может отсутствовать
       */
      "subscription": {
        "type": "Signal.Subscription",
        "text": "Информация о подписке с которой связан сигнал.\nХарактеризует что доступно или не доступно пользователю.\nЗаполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.\nМожет отсутствовать",
      },
      /**
       * Информация о выставленном счёте с которым связан сигнал.
       * Характеризует состояние оплаты.
       * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
       * Может отсутствовать
       */
      "invoice": {
        "type": "Signal.Invoice",
        "text": "Информация о выставленном счёте с которым связан сигнал.\nХарактеризует состояние оплаты.\nЗаполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.\nМожет отсутствовать",
      },
      /**
       * Информация о объекте действия с которым связан сигнал.
       * К чему сигнал относится.
       * Заполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.
       * Может отсутствовать
       */
      "object": {
        "type": "Signal.Entity",
        "text": "Информация о объекте действия с которым связан сигнал.\nК чему сигнал относится.\nЗаполнено если такая информация присутствует в програмном модуле обрабатывающий запрос, иначе пусто.\nМожет отсутствовать",
      },
      /**
       * Дополнительная полезная нагрузка.
       * К примеру тэги.
       * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
       */
      "payload": {
        "type": "{[key:string]:string}",
        "text": "Дополнительная полезная нагрузка.\nК примеру тэги.\nТут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна",
      },
      /**
       * Мета информация.
       * Некоторая информация которая присутствует в запросе.
       * К примеру это http заголовки запроса: X-Request-Id, User-Agent, X-Forwarded-For и тд
       */
      "meta": {
        "type": "{[key:string]:string}",
        "text": "Мета информация.\nНекоторая информация которая присутствует в запросе.\nК примеру это http заголовки запроса: X-Request-Id, User-Agent, X-Forwarded-For и тд",
      },
    },
  },
  /**
   * Сущность
   */
  "Signal.Entity": {
    "kind": "class",
    "text": "Сущность",
    "fields": {
      /**
       * Область размещения.
       * Обычно это идентификатор дома в стандарте ОРПОН.
       * Может отсутствовать
       */
      "placeId": {
        "type": "string",
        "text": "Область размещения.\nОбычно это идентификатор дома в стандарте ОРПОН.\nМожет отсутствовать",
      },
      /**
       * Место размещение.
       * Обычно это номер квартиры.
       * Может отсутствовать
       */
      "placeLabel": {
        "type": "string",
        "text": "Место размещение.\nОбычно это номер квартиры.\nМожет отсутствовать",
      },
      /**
       * Идентификатор пользователя.
       * Может отсутствовать
       */
      "userId": {
        "type": "string",
        "text": "Идентификатор пользователя.\nМожет отсутствовать",
      },
      /**
       * Лейбл пользователя.
       * Обычно это тип/роль пользователя.
       * Может отсутствовать
       */
      "userLabel": {
        "type": "string",
        "text": "Лейбл пользователя.\nОбычно это тип/роль пользователя.\nМожет отсутствовать",
      },
      /**
       * Идентификатор группы.
       * Обычно это идентификатор компании.
       * Может отсутствовать
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\nОбычно это идентификатор компании.\nМожет отсутствовать",
      },
      /**
       * Название группы.
       * Обычно это название компании.
       * Может отсутствовать
       */
      "groupTitle": {
        "type": "string",
        "text": "Название группы.\nОбычно это название компании.\nМожет отсутствовать",
      },
      /**
       * Идентификатор устройства.
       * Может отсутствовать
       */
      "deviceId": {
        "type": "string",
        "text": "Идентификатор устройства.\nМожет отсутствовать",
      },
      /**
       * Лейбл устройства.
       * Может отсутствовать
       */
      "deviceLabel": {
        "type": "string",
        "text": "Лейбл устройства.\nМожет отсутствовать",
      },
      /**
       * Индекс реле устройства.
       * Может отсутствовать
       */
      "deviceRelayIndex": {
        "type": "string",
        "text": "Индекс реле устройства.\nМожет отсутствовать",
      },
      /**
       * Идентификатор камеры.
       * Может отсутствовать
       */
      "cameraId": {
        "type": "string",
        "text": "Идентификатор камеры.\nМожет отсутствовать",
      },
      /**
       * Лейбл камеры.
       * Может отсутствовать
       */
      "cameraLabel": {
        "type": "string",
        "text": "Лейбл камеры.\nМожет отсутствовать",
      },
      /**
       * Номер ключа.
       * Может отсутствовать
       */
      "key": {
        "type": "string",
        "text": "Номер ключа.\nМожет отсутствовать",
      },
      /**
       * Код.
       * Может отсутствовать
       */
      "code": {
        "type": "string",
        "text": "Код.\nМожет отсутствовать",
      },
      /**
       * ДТМФ код открытия.
       * Может отсутствовать
       */
      "dtmfCode": {
        "type": "string",
        "text": "ДТМФ код открытия.\nМожет отсутствовать",
      },
      /**
       * Номер телефона.
       * Может отсутствовать
       */
      "phone": {
        "type": "string",
        "text": "Номер телефона.\nМожет отсутствовать",
      },
      /**
       * Дополнительная полезная нагрузка.
       * К примеру дополнительные детали сущности.
       * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
       */
      "payload": {
        "type": "{[key:string]:string}",
        "text": "Дополнительная полезная нагрузка.\nК примеру дополнительные детали сущности.\nТут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна",
      },
      /**
       * Почтовый адрес.
       * Может отсутствовать
       */
      "email": {
        "type": "string",
        "text": "Почтовый адрес.\nМожет отсутствовать",
      },
    },
  },
  /**
   * Информация о выставленном счёте
   */
  "Signal.Invoice": {
    "kind": "class",
    "text": "Информация о выставленном счёте",
    "fields": {
      /**
       * Идентификато выставленного счёта.
       * Может отсутствовать
       */
      "id": {
        "type": "string",
        "text": "Идентификато выставленного счёта.\nМожет отсутствовать",
      },
      /**
       * Назначение выставленного счёта.
       * Может отсутствовать
       */
      "title": {
        "type": "string",
        "text": "Назначение выставленного счёта.\nМожет отсутствовать",
      },
      /**
       * Общая сумма чека.
       * В рублях.
       * Может отсутствовать
       */
      "totalAmount": {
        "type": "float",
        "text": "Общая сумма чека.\nВ рублях.\nМожет отсутствовать",
      },
      /**
       * Статус выставленного счёта.
       * Может отсутствовать
       */
      "status": {
        "type": "string",
        "text": "Статус выставленного счёта.\nМожет отсутствовать",
      },
      /**
       * Номер телефона на который пользователь хочет получить информацию об оплате.
       * Может отсутствовать
       */
      "phone": {
        "type": "string",
        "text": "Номер телефона на который пользователь хочет получить информацию об оплате.\nМожет отсутствовать",
      },
      /**
       * Почта на которую пользователь хочет получить информацию об оплате.
       * Может отсутствовать
       */
      "email": {
        "type": "string",
        "text": "Почта на которую пользователь хочет получить информацию об оплате.\nМожет отсутствовать",
      },
      /**
       * Идентификаторы товаров позиций на которые выставленн счёт.
       * Обычно это идентификаторы подписок.
       * Может отсутствовать
       */
      "positionIds": {
        "type": "string",
        "text": "Идентификаторы товаров позиций на которые выставленн счёт.\nОбычно это идентификаторы подписок.\nМожет отсутствовать",
      },
      /**
       * Дополнительная полезная нагрузка.
       * К примеру дополнительные детали выставленного счёта.
       * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
       */
      "payload": {
        "type": "{[key:string]:string}",
        "text": "Дополнительная полезная нагрузка.\nК примеру дополнительные детали выставленного счёта.\nТут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна",
      },
    },
  },
  /**
   * Информация о подписке
   */
  "Signal.Subscription": {
    "kind": "class",
    "text": "Информация о подписке",
    "fields": {
      /**
       * Идентификатор подписки.
       * Может отсутствовать
       */
      "id": {
        "type": "string",
        "text": "Идентификатор подписки.\nМожет отсутствовать",
      },
      /**
       * Название подписки.
       * Может отсутствовать
       */
      "title": {
        "type": "string",
        "text": "Название подписки.\nМожет отсутствовать",
      },
      /**
       * Статус подписки.
       * Может отсутствовать
       */
      "status": {
        "type": "string",
        "text": "Статус подписки.\nМожет отсутствовать",
      },
      /**
       * Привилегии подписок.
       * Может отсутствовать
       */
      "privileges": {
        "type": "string",
        "text": "Привилегии подписок.\nМожет отсутствовать",
      },
      /**
       * Дополнительная полезная нагрузка.
       * К примеру дополнительные детали подписки.
       * Тут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна
       */
      "payload": {
        "type": "{[key:string]:string}",
        "text": "Дополнительная полезная нагрузка.\nК примеру дополнительные детали подписки.\nТут можно поместить ту информацию которая не вошла в схему, но будет полезна или стала нужна",
      },
    },
  },
}